import { Box, Button, Flex, HStack, Image } from "@chakra-ui/react";
import { useEffect, useState } from 'react';
import AdminDashboardHeader from "../../../components/admin/AdminHeader";
import AdminSidebar from "../../../components/admin/AdminSidebar";
import SponsorPaymentAmount from "../../../components/admin/sponsor/payment/PaymentAmount";
import SponsorVerifyPayment from "../../../components/admin/sponsor/payment/VerifyPayment";
import RegisterLine from "../../../components/trainee/register/RegisterLine";
import rarrow from '../../../img/rarrow.svg';


const SponsorPayment = () => {

    const [pageState, setPagestate] = useState(0);
    const pages = [
        { index: 1, component: SponsorPaymentAmount },
        { index: 2, component: SponsorVerifyPayment },

    ]

    const switchPage = () => {

        const Component = pages[pageState].component;
        return <Component nextPage={nextPage} prePage={prePage} />

    }


    const nextPage: any = () => {
        if (pageState < pages.length) {
            setPagestate(+pageState)
        }
        localStorage.setItem("sponsor_payment_no", pageState.toString());
    }

    const prePage = () => {
        if (pageState > 0) {
            setPagestate(-pageState)
        }
        localStorage.setItem("sponsor_payment_no", pageState.toString());
    }

    useEffect(() => {
        const pageNo = localStorage.getItem("sponsor_payment_no") ?? '0'

        setPagestate(parseInt(pageNo));
    }, []);

    const clearCourseFromLocalStorage = () => {

        window.location.reload();
    }

    return (
        <>
            <Flex>
                <Box width='18%' position='fixed' top='0' left='0' zIndex='1'>
                    <AdminSidebar />
                </Box>

                <Box width='82%' ml='18%' >
                    <AdminDashboardHeader />
                    <Box bg='#F9F8F8' height='100%' pt='30px' pl='20px' pr='40px'>
                <Flex justifyContent="center" bg='#F9F8F8' height='100%' bgSize='cover'>
                    <Box mt='50px' width='60%' mx='auto'>
                        <Box pt='50px' bg='white' boxShadow="0px 0px 4px rgba(0, 0, 0, 0.08)" px={8} >

                            <Flex justifyContent='center'>
                                <HStack spacing={8} >
                                    <RegisterLine fontWeight={pageState === 0 ? "700" : "400"} position="1" title="Payment Amount" bgColor={pageState === 0 ? "brand.2" : "brand.1"} textColor={pageState === 0 ? "#EC3337" : "#616161"} />


                                    <Image src={rarrow} />


                                    <RegisterLine fontWeight={pageState === 1 ? "700" : "400"} position="2" title="Verify Payment" bgColor={pageState === 1 ? "brand.2" : "brand.1"} textColor={pageState === 1 ? "#EC3337" : "#616161"} />


                                </HStack>
                            </Flex>

                        </Box>
                        <Box boxShadow="base" bg="white" mb='50px' py={4} px={8} >

                            {
                                switchPage()
                            }


                            <Flex justifyContent="center" mt={6} px={6}>

                                {
                                    pageState >= 0 && pageState < 1 ?
                                        <Button onClick={nextPage} py='13px' px='30px' type="submit" fontSize={11} borderRadius={0} colorScheme='red' size='sm'>NEXT</Button> :
                                        <Button variant='outline' onClick={prePage} py='13px' px='30px' type="submit" fontSize={11} borderRadius={0} colorScheme='red' size='sm'>BACK</Button>}


                            </Flex>
                        </Box>

                    </Box>
                </Flex>



            </Box>

                </Box>
            </Flex>
    

        </>
    );
}

export default SponsorPayment;